import {
  MyTaskPageHeader,
  QuestionCreationTaskDetailsModalProvider,
  QuestionCreationTaskDetailsProvider,
} from '@exam-management/question-creation-task-details';
import { useParams } from '@exam-management/router';
import { TaskManagementPermissionRoute } from '@exam-management/task-management';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationLayout() {
  const { taskId } = useParams('/my-task/question-creation/:taskId');

  return (
    <TaskManagementPermissionRoute taskId={taskId}>
      <QuestionCreationTaskDetailsProvider taskId={taskId}>
        <QuestionCreationTaskDetailsModalProvider>
          <Flex sx={{ flexDirection: 'column', height: '100%' }}>
            <MyTaskPageHeader />
            <Outlet />
          </Flex>
        </QuestionCreationTaskDetailsModalProvider>
      </QuestionCreationTaskDetailsProvider>
    </TaskManagementPermissionRoute>
  );
}
